import { render, staticRenderFns } from "./TreeAccordion.vue?vue&type=template&id=10926433"
import script from "./TreeAccordion.vue?vue&type=script&lang=ts"
export * from "./TreeAccordion.vue?vue&type=script&lang=ts"
import style0 from "./TreeAccordion.vue?vue&type=style&index=0&id=10926433&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports